import { useState } from 'react';
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';

// project imports
import Logo from 'components/logo';
import { handlerDrawerOpen } from 'api/menu';

// material-ui
import useMediaQuery from '@mui/material/useMediaQuery';

// assets
import MenuOpenIcon from '@mui/icons-material/MenuOpen';
import MenuIcon from '@mui/icons-material/Menu';

// ==============================|| DRAWER HEADER - STYLED ||============================== //

const DrawerHeaderStyled = styled(Box, { shouldForwardProp: (prop) => prop !== 'open' })(({ theme }) => ({
  ...theme.mixins.toolbar,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  paddingLeft: theme.spacing(0),
  backgroundColor: '#ffffff',
  color: theme.palette.text.primary,
  cursor: 'pointer',
  variants: [
    {
      props: ({ open }) => open,
      style: { justifyContent: 'space-between', paddingLeft: theme.spacing(3) }
    }
  ]
}));

// ==============================|| DRAWER HEADER ||============================== //

export default function DrawerHeader({ open }) {
  const [hovered, setHovered] = useState(false);
  const downLG = useMediaQuery((theme) => theme.breakpoints.down('lg'));

  return (
    <DrawerHeaderStyled
      open={open}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      onClick={() => handlerDrawerOpen(!open)}
      sx={{
        minHeight: '60px',
        width: 'initial',
        paddingTop: '8px',
        paddingBottom: '8px',
        paddingRight: open ? '12px' : 0
      }}
    >
      {open ? (
        <>
          <Logo isIcon={false} sx={{ width: 'auto', height: 35 }} />
          {!downLG &&
            <IconButton
              disableRipple
              aria-label="close drawer"
              sx={{ color: '#047857', '&:hover': { backgroundColor: 'transparent' } }}
            >
              <MenuOpenIcon style={{ fontSize: 40 }} />
            </IconButton>
          }
        </>
      ) : hovered ? (
        <IconButton
          disableRipple
          aria-label="open drawer"
          sx={{
            color: '#047857',
            px: 5,
            py: '28px',
            '&:hover': { backgroundColor: 'transparent' }
          }}
        >
          <MenuIcon style={{ fontSize: 40 }} />
        </IconButton>
      ) : (
        <Logo isIcon={true} sx={{ width: 35, height: 35 }} />
      )}
    </DrawerHeaderStyled>
  );
}

DrawerHeader.propTypes = { open: PropTypes.bool };